// Semantic UI Adapter (frontend half). Maps a STABLE coach target id to a live
// DOM element. Prefers a dedicated `data-coach-target` contract attribute so that
// cosmetic changes / QA data-testid churn don't break walkthroughs; falls back to
// the matching data-testid during the slice.
export function resolveTarget(targetId) {
  if (!targetId) return null;
  return (
    document.querySelector(`[data-coach-target="${targetId}"]`) ||
    document.querySelector(`[data-testid="${targetId}"]`)
  );
}
